<template>
  <div class="container">
    <a class="describe">{{ data.title }}</a>
    <a class="main-info">{{ data.value | regroupWan(data.toFixed) }}</a>
    <div class="describe">
      <a style="padding-right: 10px">昨日</a>
      <a class="yesterday-info">{{
        data.yes == 0 ? '-' : data.yes | regroupWan
      }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cpn-cards',
  props: {
    data: { type: Object },
  },
  filters: {
    regroupWan(num, toFixed) {
      if (num >= 10000) {
        return (num / 10000).toFixed(toFixed || 2) + '万';
      } else if (`${num}`.includes('.')) {
        return num.toFixed(toFixed || 2);
      } else {
        return toFixed ? Number(num).toFixed(toFixed) : num;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

.container {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  padding: 13px 18px;
  width: 220px;
  height: 120px;
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 24px;
}

.describe {
  font-size: 16px;
}
.main-info {
  color: $--color-primary;
  font-size: 24px;
}

.yesterday-info {
  color: #8c8c8c;
}
</style>
